import { Injectable } from '@angular/core';

export interface DocumentInfo {
  clientId: string;
  componentId: string;
  partNumber: string;
  serialNumber: string;
  token?: string;
}

@Injectable({
  providedIn: 'root',
})
export class DocumentStateService {
  private documentInfo!: DocumentInfo;

  setDocumentInfo(info: DocumentInfo) {
    this.documentInfo = info;
  }

  getDocumentInfo(): DocumentInfo | null {
    return this.documentInfo ?? null;
  }
}
